import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import { produce } from "immer";
import { localApi, inshaApi } from "utils/imgApi";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styleCheck from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

import { credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyleSweet = makeStyles(styleSweet);
const useStyle = makeStyles(style);
const useStyCheck = makeStyles(styleCheck);

export default function AddMetal(props) {
  const [metdesc, setMetalDesc] = React.useState("");
  const [different, setDifferent] = React.useState("");
  const [price, setPrice] = React.useState("");
  const [gst, setGst] = React.useState("");
  const [metErr, setMetErr] = React.useState("");
  const [differentErr, setDifferentErr] = React.useState("");
  const [priceErr, setPriceErr] = React.useState("");
  const [gstErr, setGstErr] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");

  const [newMetal, setNewMetal] = React.useState(false);
  const [btn, setBtn] = React.useState(false);

  const [items, setItems] = React.useState([]);
  const [active, setActive] = React.useState(false);
  const [multipleSelect, setMultipleSelect] = React.useState([]);
  const [newDefChild, setNewDefChild] = React.useState(false);
  const [multipleSelectErr, setMultipleSelectErr] = React.useState("");

  const classes = useStyles();
  const classSweet = useStyleSweet();
  const classe = useStyle();
  const classCheck = useStyCheck();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  async function getUsers() {
    const api =
      inshaApi + `/rawprice/list/byAdminId/2`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    setItems(getResult && getResult);
    // console.log(getResult);
  }

  useEffect(() => {
    getUsers();
  }, []);

  const handleMultiple = event => {
    setMultipleSelect(event.target.value);
    setMultipleSelectErr("")
  };

  const handleMetalDesc = (index) => (e) => {
    let title = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].title = title;
      })
    );
  };

  const handlePrice = (index) => (e) => {
    let price = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].price = price;
      })
    );
  };

  const handleDifferent = (index) => (e) => {
    let different = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].different = different;
      })
    );
  };

  const handleGst = (index) => (e) => {
    let taxPercentage = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].taxPercentage = taxPercentage;
      })
    );
  };

  const SubmitAddDefaultMetal = (e) => {
    setNewDefChild(true);
    let errorCount = 0;
    if (!Array.isArray(multipleSelect) || multipleSelect.length < 2) {
      errorCount++;
      setMultipleSelectErr("Select at least two Product Metal");
    }
    if (errorCount === 0) {
      // console.log(multipleSelect.map((m) => {
      //   return {
      //     title: m.title,
      //     different: m.different,
      //     price: m.price,
      //     taxPercentage: m.taxPercentage,
      //   }
      // }));

      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify(multipleSelect.map((m) => {
          return {
            title: m.title,
            different: m.different,
            price: m.price,
            taxPercentage: m.taxPercentage,
          }
        })),
      };
      fetch(localApi + `/rawprice/addAll/${userObj.id}`, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          }
        });
    }
  }

  const SubmitAddMetal = () => {
    setNewMetal(true);
    let errorCount = 0;
    if (metdesc === "" || !metdesc) {
      errorCount++;
      setMetErr("Pipe/Golwire is Required");
    }

    if (different === "" || !different) {
      errorCount++;
      setDifferentErr("Different Price is Required");
    }

    if (price === "" || !price) {
      errorCount++;
      setPriceErr("Price is Required");
    }

    if (gst === "" || !gst) {
      errorCount++;
      setGstErr("GST is Required");
    }

    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify({
          title: metdesc,
          different: different,
          price: price,
          taxPercentage: gst,
        }),
      };

      fetch(localApi + `/rawprice/add/${userObj && userObj.id}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully");
            setSubmitted(true);
          }
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={active === true ? 12 : 12} md={active === true ? 12 : 6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <AddIcon />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Add Raw Metal</small>
                {active === true ? newDefChild === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {multipleSelectErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Enter Pipe/Golwire
                  </small>
                ) : newMetal === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {metErr || differentErr || priceErr || gstErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Enter Pipe/Golwire
                  </small>
                )}
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >Added Raw Metal</SweetAlert>
                ) : null}{" "}
                {active === false ? <>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Pipe/Golwire Thaw..."
                      id="metdesc"
                      inputProps={{
                        placeholder: "Ex. Rolling Dall Patti/Lasiya...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="metdesc"
                      value={metdesc}
                      onChange={(e) => {
                        setMetalDesc(e.target.value);
                        setMetErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{metErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Metal Price..."
                      id="price"
                      inputProps={{
                        placeholder: "Ex. 610...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="price"
                      value={price}
                      onChange={(e) => {
                        setPrice(e.target.value);
                        setPriceErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{priceErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Different Price..."
                      id="different"
                      inputProps={{
                        placeholder: "Ex. 8...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="different"
                      value={different}
                      onChange={(e) => {
                        setDifferent(e.target.value);
                        setDifferentErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{differentErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Tax Rate..."
                      id="gst"
                      inputProps={{
                        placeholder: "Ex. 18...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="gst"
                      value={gst}
                      onChange={(e) => {
                        setGst(e.target.value);
                        setGstErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{gstErr}</span> */}
                  </GridItem>
                </> : ""}

                <GridItem xs={12} sm={12} md={12}>
                  <FormControlLabel
                    classes={{
                      root: classCheck.checkboxLabelControl,
                      label: classCheck.checkboxLabel,
                    }}
                    control={
                      <Checkbox
                        id="active"
                        value={active}
                        checked={
                          active & (active === true) ? active : active
                        }
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setActive(checked);
                          if (!checked) {
                            // If checkbox is unchecked, clear multipleSelect
                            setMultipleSelect([]);
                            setMultipleSelectErr(""); // Also clear any errors if needed
                          }
                        }}
                        tabIndex={-1}
                        checkedIcon={
                          <Check className={classCheck.checkedIcon} />
                        }
                        icon={
                          <Check className={classCheck.uncheckedIcon} />
                        }
                        classes={{
                          checked: classCheck.checked,
                          root: classCheck.checkRoot,
                        }}
                      />
                    }
                    label={
                      <span style={{ color: "#9c27b0" }}>
                        Would you like to save the default Metal?
                      </span>
                    }
                  />
                </GridItem>

                {active === true ?
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classe.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="multiple-select"
                        className={classe.selectLabel}
                      >
                        Select Raw Metal Name...
                      </InputLabel>
                      <Select
                        multiple
                        value={multipleSelect}
                        onChange={handleMultiple}
                        MenuProps={{ className: classe.selectMenu }}
                        classes={{ select: classe.select }}
                        inputProps={{
                          name: "multipleSelect",
                          id: "multiple-select"
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classe.selectMenuItem
                          }}
                        >
                          Select Raw Metal Name...
                        </MenuItem>
                        {items &&
                          items.map((item2) => (
                            <MenuItem
                              key={item2.id}
                              value={item2}
                              classes={{
                                root: classe.selectMenuItem,
                                selected: classe.selectMenuItemSelectedMultiple,
                              }}
                            >
                              {item2.title}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  : ""}
              </GridContainer>
              <GridContainer>
                {multipleSelect &&
                  multipleSelect.map((Ele, index) => (
                    <GridItem xs={12} sm={6} md={4} key={Ele.id} value={Ele.id}>
                      <Card>
                        <CardBody>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText={"Pipe/Golwire Thaw..." + Ele.id}
                                id="metdesc"
                                inputProps={{
                                  placeholder: "Ex. 12 Sets in 1 Box...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="metdesc"
                                value={Ele.title}
                                onChange={handleMetalDesc(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"Metal Price..."}
                                id="price"
                                inputProps={{
                                  placeholder: "Ex. 610...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="price"
                                value={Ele.price}
                                onChange={handlePrice(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"Different Price..."}
                                id="different"
                                inputProps={{
                                  placeholder: "Ex. 8...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="different"
                                value={Ele.different}
                                onChange={handleDifferent(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"Tax Rate..."}
                                id="gst"
                                inputProps={{
                                  placeholder: "Ex. 18...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="gst"
                                value={Ele.taxPercentage}
                                onChange={handleGst(index)}
                              />
                            </GridItem>
                          </GridContainer>
                        </CardBody>
                      </Card>
                    </GridItem>
                  ))}
              </GridContainer>
              {/* <Button
                color="rose"
                onClick={SubmitAddMetal}
                className={classes.updateProfileButton}
              >
                Save
              </Button> */}
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Save</Button>
              ) : (
                active === true ? (
                  <Button
                    color="rose"
                    onClick={SubmitAddDefaultMetal}
                    className={classes.updateProfileButton}
                  >
                    Save Default
                  </Button>
                ) :
                  <Button
                    color="rose"
                    onClick={SubmitAddMetal}
                    className={classes.updateProfileButton}
                  >
                    Save
                  </Button>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
